/*
import wor_fro_hei_haz_lev from "./img/sswpIcons/FallingObjects/sswpicon_falls_falling_objects_ver2.jpg";
import wor_fro_hei_edg_pro from "./img/sswpIcons/FallingObjects/sswpicon_falls_falling_objects_edge_protection.jpg";
import wor_fro_hei_mewp from "./img/sswpIcons/FallingObjects/sswpicon_falls_falling_objects_mewp.jpg";
import wor_fro_hei_ope_hol from "./img/sswpIcons/FallingObjects/sswpicon_falls_falling_objects_open_holes.jpg";
import wor_fro_hei_pro from "./img/sswpIcons/FallingObjects/sswpicon_falls_falling_objects_propping.jpg";
import wor_fro_hei_bar from "./img/sswpIcons/FallingObjects/sswpicon_falls_falling_objects_barriers.jpg";
import wor_fro_hei_har from "./img/sswpIcons/FallingObjects/sswpicon_falls_falling_objects_harness.jpg";
import wor_fro_hei_lad from "./img/sswpIcons/FallingObjects/sswpicon_falls_falling_objects_ladder.jpg";
import wor_fro_hei_ris_ass from "./img/sswpIcons/FallingObjects/sswpicon_falls_falling_objects_risk_assess.jpg";
import wor_fro_hei_saf_lad from "./img/sswpIcons/FallingObjects/sswpicon_falls_falling_objects_safe_ladder.jpg";
import wor_fro_hei_sca from "./img/sswpIcons/FallingObjects/sswpicon_falls_falling_objects_scaffolding.jpg";
import wor_fro_hei_sop from "./img/sswpIcons/FallingObjects/sswpicon_falls_falling_objects_sop.jpg";
import wor_fro_hei_sur from "./img/sswpIcons/FallingObjects/sswpicon_falls_falling_objects_survey.jpg";
import wor_fro_hei_tie_lad from "./img/sswpIcons/FallingObjects/sswpicon_falls_falling_objects_tie_ladder.jpg";
import wor_fro_hei_tre_pla from "./img/sswpIcons/FallingObjects/sswpicon_falls_falling_objects_trestle_platform.jpg";
import wor_fro_hei_wor_pla from "./img/sswpIcons/FallingObjects/sswpicon_falls_falling_objects_working_platform.jpg";
import wor_fro_hei_wea from "./img/sswpIcons/FallingObjects/sswpicon_falls_falling_objects_weather.jpg";
import wor_fro_hei_war_sig from "./img/sswpIcons/FallingObjects/sswpicon_falls_falling_objects_warning_signs.jpg";
*/

import SupervisionHazards from "./Hazards/Supervision";
import PPEHazards from "./Hazards/PPE";
import TrafficHazards from "./Hazards/Traffic";
import WorkingCloseToPublicHazards from "./Hazards/WorkingCloseToPublic";
import PlantAndEquipmentHazards from "./Hazards/PlantAndEquipment";
import HandToolsHazards from "./Hazards/HandTools";
import ExcavationHazards from "./Hazards/Exacavation";
import SewersHazards from "./Hazards/Sewers";
import WorkingCloseToWaterHazards from "./Hazards/WorkingCloseToWater";
import SubstancesHazards from "./Hazards/Substances";
import BiologicalAgentsHazards from "./Hazards/BiologicalAgents";
import AsbestosHazards from "./Hazards/Asbestos";
import ConfinedSpace from "./Hazards/ConfinedSpace";
import OtherItemsHazard from "./Hazards/OtherItems";
import ManualHandlingHazards from "./Hazards/ManualHandling";
import HealthHazards from "./Hazards/Health";
import GroundFloorHazards from "./Hazards/GroundFloor";
import RoofWorkHazards from "./Hazards/RoofWork";
import UpperFloorHazards from "./Hazards/UpperFloor";
import InSituHazards from "./Hazards/InSitu";
import PreCastHazards from "./Hazards/PreCast";
import SteelWorksHazards from "./Hazards/SteelWorks";
import CovidHazards from "./Hazards/Covid";

import FallsFallingObjectsHazards from "./Hazards/FallsFallingObjects";
import InfestationHazards from "./Hazards/Infestation";
import DustHazards from "./Hazards/Dust";
import LoneWorkingViolenceHazards from "./Hazards/LoneWorkingViolence";
import FireHazards from "./Hazards/Fire";
import DemolitionMethod from "./Hazards/DemolitionMethod";
import RockBlast from "./Hazards/RockBlast";
import HarmfulGas from "./Hazards/HarmfulGas";
const json = {
    cov_haz_lev: CovidHazards,
    sup_haz_lev: SupervisionHazards,
    tra_haz_lev: TrafficHazards,
    wcp_haz_lev: WorkingCloseToPublicHazards,
    pla_haz_lev: PlantAndEquipmentHazards,
    han_haz_lev: HandToolsHazards,
    exc_haz_lev: ExcavationHazards,
    fal_fal_haz_lev: FallsFallingObjectsHazards,
    ser_haz_lev: SewersHazards,
    wor_clo_to_wat_haz_lev: WorkingCloseToWaterHazards,
    sub_haz_lev: SubstancesHazards,
    bio_age_haz_lev: BiologicalAgentsHazards,
    asb_haz_lev: AsbestosHazards,
    con_spa_haz_lev: ConfinedSpace,
    inf_haz_lev: InfestationHazards,
    dus_haz_lev: DustHazards,
    lon_haz_lev: LoneWorkingViolenceHazards,
    fir_haz_lev: FireHazards,
    ham_gas_haz_lev: HarmfulGas,
    insitu_haz_lev: InSituHazards,
    pre_cast_haz_lev: PreCastHazards,
    ste_wor_haz_lev: SteelWorksHazards,
    gro_flo_haz_lev: GroundFloorHazards,
    upp_flo_haz_lev: UpperFloorHazards,
    roo_wor_haz_lev: RoofWorkHazards,
    dem_haz_lev: DemolitionMethod,
    roc_bla_haz_lev: RockBlast,
    gen_haz_lev: OtherItemsHazard,
    hea_haz_lev: HealthHazards,
    man_han_haz_lev: ManualHandlingHazards,
    ppe_haz_lev: PPEHazards,

    /* wor_fro_hei_haz_lev: {
        icon: wor_fro_hei_haz_lev,
        name: "Working From Heights",
        text: "",
        icons: {
            wor_fro_hei_edg_pro: {
                name: "Edge Protection",
                icon: wor_fro_hei_edg_pro,
                text:
                    "All people must be protected from falling off edges, through hazardous openings or off stairs. Protection measures include handrails, barriers, mid-rails and toe boards, etc."
            },
            wor_fro_hei_mewp: {
                name: "MEWP",
                icon: wor_fro_hei_mewp,
                text:
                    "A boom hoist, which has an extendable folding boom with cage attached, can be used for work at height if ground conditions are suitable. Boom hoists can also be used to enable access to remote areas. Selection must be based on suitability for the task. Particular attention should be given to ground conditions. It should be possible to follow fully the manufacturer’s guidelines for safe use. Only competent and trained operators should control the movement of these hoists. Other vehicles should be strictly controlled in the vicinity of hoists. Scissors lifts that can extend to significant heights, using hydraulic scissors movement, may be used where scaffold platforms are not possible. Selection must be based on suitability for the task. Particular attention should be given to ground conditions. It should be possible to follow fully the manufacturer’s guidelines for safe use. Only competent and trained operators should control their movement."
            },
            wor_fro_hei_ope_hol: {
                name: "Open Holes",
                icon: wor_fro_hei_ope_hol,
                text:
                    "All ground and manhole openings, etc, as soon as they are created, must be guarded to prevent falls. Usually the opening is surrounded with visible guard rails and toe boards that are anchored and fixed securely. Where openings are covered, the covers (eg, manhole covers) must be of adequate strength and size and be firmly fixed in position. These covers may also identify what they are covering (eg, a floor opening) so they will not be inadvertently removed. Excavated openings should be backfilled as soon as possible."
            },
            wor_fro_hei_pro: {
                name: "Propping",
                icon: wor_fro_hei_pro,
                text:
                    "Propping is required during the construction stages of a project to give temporary support to prevent collapse due to overloading of structural components (eg, when installing precast slabs and stairs, etc). The contractor must ensure that the number and location of the props – as specified by the designer (generally a structural engineer) – are correct and that the units are supported as indicated on the construction drawings. Normally a temporary works coordinator should be appointed to ensure that correct propping procedures are followed and operations are carried out safely."
            },
            wor_fro_hei_bar: {
                name: "Barriers",
                icon: wor_fro_hei_bar,
                text: ""
            },
            wor_fro_hei_har: {
                name: "Harness",
                icon: wor_fro_hei_har,
                text: ""
            },
            wor_fro_hei_lad: {
                name: "Ladder",
                icon: wor_fro_hei_lad,
                text:
                    "All ladder access must be erected by competent people who will ensure: adequate length of ladder, tying and footing, and lack of defects. Access onto and egress off ladders must be such that workers do not have to cross large gaps through which they could fall before they have a firm handhold on the ladder. Ladders should be controlled and checked frequently to ensure fitness for use."
            },
            wor_fro_hei_ris_ass: {
                name: "Risk Assess",
                icon: wor_fro_hei_ris_ass,
                text: ""
            },
            wor_fro_hei_saf_lad: {
                name: "Safe Ladder",
                icon: wor_fro_hei_saf_lad,
                text: ""
            },
            wor_fro_hei_sca: {
                name: "Scaffolding",
                icon: wor_fro_hei_sca,
                text:
                    "Scaffold platforms should where possible be used as working platforms for all work at height and in particular for all works above two metres. The scaffold platform must be designed, planned and erected by trained personnel, in accordance with all relevant legislation, codes of practice and manufacturer’s instructions. Scaffolds should include dedicated ladder access bays, and where required, properly constructed loading bays. Hand-Over Certificates and the use of relevant signage (eg, capacity of loading bays) are recommended. "
            },
            wor_fro_hei_sop: {
                name: "SOP",
                icon: wor_fro_hei_sop,
                text: ""
            },
            wor_fro_hei_sur: {
                name: "Survey",
                icon: wor_fro_hei_sur,
                text: ""
            },
            wor_fro_hei_tie_lad: {
                name: "Tie Ladder",
                icon: wor_fro_hei_tie_lad,
                text:
                    "All ladders must be tied or footed so that, when in use, they will not slip or slide."
            },
            wor_fro_hei_tre_pla: {
                name: "Trestle Platform",
                icon: wor_fro_hei_tre_pla,
                text: ""
            },
            wor_fro_hei_wor_pla: {
                name: "Working Platform",
                icon: wor_fro_hei_wor_pla,
                text:
                    "A working platform is a location for carrying out construction work at height safely. It is taken to mean a work area that provides protection and prevents a worker from falling to a lower level. Generally it is used to refer to scaffold platforms but, where scaffolds cannot be erected, it can also refer to other safe platforms such as MEWPs and scaffold towers."
            },
            wor_fro_hei_wea: {
                name: "Weather",
                icon: wor_fro_hei_wea,
                text: ""
            },
            wor_fro_hei_war_sig: {
                name: "Warning Signs",
                icon: wor_fro_hei_war_sig,
                text: ""
            }
        }
    },*/
};

export default json;
